export let hres3cuColumns = () => {
  let indexColumns = [{
    key: 'numcom',
    name: '',
    labelCodapp: 'HRES3CUC1',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'dtecompl',
    name: '',
    labelCodapp: 'HRES3CUC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES3CUC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRES3CUC1',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_typcomp',
    name: '',
    labelCodapp: 'HRES3CUC1',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES3CUC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }]

  let detailProcessColumns = [{
    key: 'dteopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'codopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'desopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'limopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }]

  let complaintsColumns = [{
    key: 'dteopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'codopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '60',
    style: 'min-width: 120px;'
  }, {
    key: 'desc_codopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'desopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'limopert',
    name: '',
    labelCodapp: 'HRES3CUC2',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      index: indexColumns,
      detailProcess: detailProcessColumns,
      complaintsTab1Table: complaintsColumns
    },
    th: {
      index: indexColumns,
      detailProcess: detailProcessColumns,
      complaintsTab1Table: complaintsColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres3cu.js